import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { APPLICATION_ID, STATIC_ROOT } from '../../constants';

import { getRefundWording } from '../../services/i18n/selector';

import { displayableCashback, renderPluralConditional } from '../../services/partner/utils';

import SvgComponent from '../SvgComponent';

import { DiscountListContainer } from './DiscountListComponentStyle';

const Discount = ({ discount, textRefund, showArrow }) => {
    const renderCashback = cashback => (
        <span className="value">
            {`${displayableCashback(cashback.percent, cashback.fixed)} ${renderPluralConditional(
                textRefund,
                () => cashback && (cashback.fixed > 1 || cashback.percent > 1)
            )}`}
        </span>
    );

    const renderWording = () => {
        if (discount.label) {
            return ` ${discount.label}`;
        }
    };

    return (
        !isEmpty(discount) && (
            <li className="discount">
                {showArrow && (
                    <SvgComponent src={`${STATIC_ROOT}/fleche.svg`} width="6" height="10" />
                )}
                {renderCashback(discount.cashback)}
                {renderWording()}
            </li>
        )
    );
};

const mapStateToProps = state => {
    return {
        refundWording: getRefundWording(state, APPLICATION_ID)
    };
};

export const DiscountListComponent = connect(mapStateToProps)(
    ({ discounts, REFUND, showArrow = false }) => {
        if (discounts && discounts.length > 0) {
            return (
                <DiscountListContainer>
                    {discounts.map(discount => (
                        <Discount
                            key={discount.id}
                            discount={discount}
                            textRefund={REFUND}
                            showArrow={showArrow}
                        />
                    ))}
                </DiscountListContainer>
            );
        }
        return null;
    }
);



// WEBPACK FOOTER //
// ./src/components/discount/DiscountListComponent.js